import type { IPmtOnboardingPopup } from '@/interfaces/tracking';
import type {
  IMainTranslation,
  INotificationTranslation,
  IPmtPage,
  ITrackingTranslation,
} from '@/modules/pmt/interfaces';
import { type FC, type MutableRefObject, createContext, useContext, useMemo, useRef } from 'react';

interface IMyParcelsProps {
  pmtPageData: IPmtPage | null;
  mainTranslation: IMainTranslation;
  trackingTranslation: ITrackingTranslation;
  notificationTranslation: INotificationTranslation;
  pmtOnboardingPopUp: IPmtOnboardingPopup;
  pmtEmailSyncOnboardingPopUp: IPmtOnboardingPopup;
}

const defaultProps: IMyParcelsProps = {
  pmtPageData: null,
  mainTranslation: {},
  trackingTranslation: {},
  notificationTranslation: {},
  pmtOnboardingPopUp: {},
  pmtEmailSyncOnboardingPopUp: {},
};

interface IMyParcelsState {
  focusFirstShipmentRef: MutableRefObject<boolean>;
}

const initialState: IMyParcelsState = {
  focusFirstShipmentRef: { current: false },
};

type IMyParcelsContext = IMyParcelsProps & IMyParcelsState;

const MyParcelsContext = createContext<IMyParcelsContext>({
  ...defaultProps,
  ...initialState,
});

export const MyParcelsProvider: FC<{
  pmtProps: IMyParcelsProps;
}> = ({ children, pmtProps }) => {
  const focusFirstShipmentRef = useRef(false);

  const ctxValue: IMyParcelsContext = useMemo(
    () => ({
      ...pmtProps,
      focusFirstShipmentRef,
    }),
    [pmtProps],
  );

  return <MyParcelsContext.Provider value={ctxValue}>{children}</MyParcelsContext.Provider>;
};

export const useMyParcelsContext = () => useContext(MyParcelsContext);
